import React from 'react';
import PhoneInput from 'react-phone-input-2';
import styled from 'styled-components';
import propTypes from 'prop-types';

const CountryCodeWrapper = styled.div`
  /* width: 64px; */
  height: 100%;
  user-select: none;
  -webkit-user-select: none;
`;

const CountryCodeSelector = ({ countryCode, setCountryCode }) => (
  <CountryCodeWrapper contentEditable={false}>
    <PhoneInput
      country={countryCode}
      value=""
      onChange={(_, country) => setCountryCode(_, country)}
      contentEditable={false}
      inputProps={{
        autoFocus: false,
      }}
    />
  </CountryCodeWrapper>
);

CountryCodeSelector.propTypes = {
  countryCode: propTypes.string.isRequired,
  setCountryCode: propTypes.func.isRequired,
};

export default CountryCodeSelector;
